/*
 * Hardway Performance — Tuning Add-On Panel ("Time for an Upgrade?")
 * Handles per-card variant dropdown(s), wholesale-adjusted pricing (baked in
 * server-side by hw-addon-card.liquid / hw-addon-card-multi.liquid), core
 * charge gating, and independent AJAX add-to-cart per card.
 * Loaded only on the 4 tuning-package product templates.
 */
(function () {
  function formatPriceCents(cents) {
    var n = Number(cents) / 100;
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          document.dispatchEvent(new CustomEvent('cart:build', { detail: cart }));
        } catch (e) {
          /* no-op: theme may not listen for these */
        }

        var selectors = [
          '[data-cart-count]',
          '.js-cart-count',
          '.cart-link__bubble-num',
          '#CartCount',
          '.cart-count-bubble',
          '.cart-count'
        ];
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(function () {
        /* best-effort only — the add itself already succeeded */
      });
  }

  function initCard(card) {
    if (card.hwAddonInit) return;
    card.hwAddonInit = true;

    var raw = card.getAttribute('data-hw-addon-variants');
    var variants = [];
    try { variants = JSON.parse(raw) || []; } catch (e) { variants = []; }
    if (!variants.length) return;

    var opt1 = card.querySelector('[data-hw-addon-opt1]');
    var opt2 = card.querySelector('[data-hw-addon-opt2]');
    var priceEl = card.querySelector('[data-hw-addon-price]');
    var priceWrap = card.querySelector('[data-hw-addon-price-wrap]');
    var compareEl = card.querySelector('[data-hw-addon-price-compare]');
    var btn = card.querySelector('[data-hw-addon-add]');
    var unavailableEl = card.querySelector('[data-hw-addon-unavailable]');
    var ccWrap = card.querySelector('[data-hw-addon-corecharge]');
    var ccCheckbox = card.querySelector('[data-hw-addon-cc-checkbox]');
    var ccText = card.querySelector('[data-hw-addon-cc-text]');
    var multiLink = card.querySelector('[data-hw-addon-multi-link]');
    if (!btn) return;

    var current = null;

    function findVariant() {
      var v1 = opt1 ? opt1.value : null;
      var v2 = opt2 ? opt2.value : null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var o1Match = v1 === null || v.o1 === v1;
        var o2Match = v2 === null || v.o2 === v2;
        if (o1Match && o2Match) return v;
      }
      return null;
    }

    function resetAddedState() {
      var addLabel = btn.getAttribute('data-label-add') || 'ADD';
      btn.classList.remove('is-added', 'is-error', 'is-loading');
      btn.textContent = addLabel;
    }

    function applyVariant(v) {
      current = v;
      resetAddedState();

      if (!v) {
        if (unavailableEl) unavailableEl.hidden = false;
        btn.disabled = true;
        btn.removeAttribute('data-variant-id');
        return;
      }
      if (unavailableEl) unavailableEl.hidden = true;
      btn.setAttribute('data-variant-id', v.id);
      if (priceEl) priceEl.textContent = formatPriceCents(v.price);
      if (multiLink && v.url) multiLink.setAttribute('href', v.url);

      var hasDealerPrice = !!(v.cap && v.cap > v.price);
      if (priceWrap) priceWrap.classList.toggle('hw-addons__card-price-wrap--sale', hasDealerPrice);
      if (compareEl) {
        compareEl.hidden = !hasDealerPrice;
        compareEl.textContent = hasDealerPrice ? formatPriceCents(v.cap) : '';
      }

      var hasCoreCharge = !!(v.ccv && v.cca);
      if (ccWrap) ccWrap.hidden = !hasCoreCharge;
      if (hasCoreCharge) {
        if (ccText) ccText.textContent = 'Core Charge: $' + v.cca;
        if (ccCheckbox) ccCheckbox.checked = false;
        btn.disabled = true; // must acknowledge core charge first
      } else {
        btn.disabled = !v.avail;
      }
      if (v.avail === false) btn.disabled = true;
    }

    if (opt1) {
      opt1.addEventListener('change', function () { applyVariant(findVariant()); });
    }
    if (opt2) {
      opt2.addEventListener('change', function () { applyVariant(findVariant()); });
    }
    if (ccCheckbox) {
      ccCheckbox.addEventListener('change', function () {
        if (!current) return;
        var hasCoreCharge = !!(current.ccv && current.cca);
        btn.disabled = hasCoreCharge ? !ccCheckbox.checked : !current.avail;
      });
    }

    // Establish initial state from whatever variant matches the markup's
    // pre-selected <option>s (falls back to the first variant in the list).
    applyVariant(findVariant() || variants[0]);
    // Re-enable the button after applyVariant's default gating if there is
    // no core charge for the initial variant (applyVariant already handles
    // this, but the very first call needs the button un-hidden-but-disabled
    // state to reflect "not yet acknowledged" only when a charge exists).

    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-loading') || !current) return;

      var addLabel = btn.getAttribute('data-label-add') || 'ADD';
      var addingLabel = btn.getAttribute('data-label-adding') || 'ADDING…';
      var addedLabel = btn.getAttribute('data-label-added') || 'Product Added to Cart';
      var errorLabel = btn.getAttribute('data-label-error') || 'TRY AGAIN';

      var items = [{ id: current.id, quantity: 1 }];
      var wantsCoreCharge = !!(current.ccv && current.cca);
      if (wantsCoreCharge) {
        if (!ccCheckbox || !ccCheckbox.checked) return; // gated — button should already be disabled
        items.push({
          id: current.ccv,
          quantity: 1,
          properties: { '_core_charge': 'true', '_core_charge_parent': String(current.id) }
        });
      }

      btn.classList.remove('is-error');
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = addingLabel;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw new Error((data && data.description) || 'Unable to add to cart');
            }
            return data;
          });
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = addedLabel;
          btn.disabled = true; // stays added — no revert, matches "Product Added to Cart" request

          refreshCartCount();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.textContent = errorLabel;
          btn.disabled = false;

          setTimeout(function () {
            btn.classList.remove('is-error');
            btn.textContent = addLabel;
          }, 2600);
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-hw-addon-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
